module.exports = __webpack_public_path__ + "img/wisdom.b01560bd.svg";